import Header from "../Header";
import Footer from "../Footer";
import Breadcrumbs from "../Breadcrumbs";
import BannerImg from "../assets/Images/banner1-1920x450.jpg";
import MainImg from "../assets/Images/about_us.jpg";
import BottomLogoImg from "../assets/Images/bottom-logo.png";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./AboutUsPage.scss";

const AboutUs = () => {
  const { t } = useTranslation();

  return (
    <>
      <Header />
      <div className="banner">
        <img src={BannerImg} alt="" />
        <div className="banner_title res">
          <h1 className="banner-main-title">{t("about_us_page_heading")}</h1>
          <p className="banner-subtitle">{t("about_us_page_heading2")}</p>
        </div>
      </div>
      <Breadcrumbs>
        <Link>{t("breadcrumbs_about_us_page_link1")}</Link>
        <span>{t("breadcrumbs_about_us_page_span")}</span>
        <Link>{t("breadcrumbs_about_us_page_link2")}</Link>
      </Breadcrumbs>
      <main className="aboutus-main-container">
        <section className="aboutus-image-section">
          <img
            src={MainImg}
            alt="About us illustration"
            className="aboutus-main-image"
          />
        </section>
        <section className="aboutus-content-section">
          <div className="aboutus-text-container">
            <p className="aboutus-paragraph">{t("about_us_page_p1")}</p>
            <p className="aboutus-paragraph">{t("about_us_page_p2")}</p>
            <p className="aboutus-paragraph">{t("about_us_page_p3")}</p>
          </div>
        </section>
        <div className="temporary">
          <img src={BottomLogoImg} alt="" className="bottom-logo" />
        </div>
      </main>
      <Footer />
    </>
  );
};

export default AboutUs;
